exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor-wrapper{width:100%;height:calc(100% - 58px);background-color:rgba(60,60,60,.5)}.ace_editor{margin:0;height:100%}.modal-page-prop .sweet-modal{max-width:1000px}.editor-container .sweet-modal{top:44%}", ""]);

// exports
